import { ShimmerBlock } from './Shimmer'

export function TransportationSkeleton() {
  return (
    <div className="container detail-page">
      <ShimmerBlock width={160} height={30} style={{ marginBottom: 20 }} />
      <div className="card-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div className="card" key={i}>
            <div className="card-body">
              <ShimmerBlock width="60%" height={18} style={{ marginBottom: 8 }} />
              <ShimmerBlock width="80%" height={14} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
